import { generatePath } from 'react-router-dom';
import { PatientRoutePrefix, PatientRoutes } from 'routes';

export const PatientRoutePattern = `${PatientRoutePrefix}/:patientId` as const;
export const getPatientLinkUrl = (route: PatientRoutes, patientId: string) =>
  generatePath(PatientRoutePattern, { patientId }) + route;
